import React from 'react';
import { useNavigate } from 'react-router-dom';
import { X, Lock } from 'lucide-react';

function SignInModal({ isOpen, onClose, redirectUrl }) {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleSignIn = () => {
    navigate(`/login?redirect=${encodeURIComponent(redirectUrl || window.location.pathname)}`);
  };

  const handleCreateAccount = () => {
    navigate(`/login?redirect=${encodeURIComponent(redirectUrl || window.location.pathname)}`);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 relative animate-fadeIn">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <X className="w-6 h-6" />
        </button>

        {/* Icon */}
        <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <Lock className="w-8 h-8 text-blue-600" />
        </div>

        {/* Content */}
        <div className="text-center mb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-3">
            Sign In Required
          </h2>
          <p className="text-gray-600">
            Please sign in or create a free account to access resources and download materials.
          </p>
        </div>

        {/* Buttons */}
        <div className="space-y-3">
          <button
            onClick={handleSignIn}
            className="w-full bg-blue-600 text-white rounded-xl px-6 py-4 font-bold hover:bg-blue-700 transition-all shadow-md hover:shadow-lg"
          >
            Sign In
          </button>
          <button
            onClick={handleCreateAccount}
            className="w-full bg-green-600 text-white rounded-xl px-6 py-4 font-bold hover:bg-green-700 transition-all shadow-md hover:shadow-lg"
          >
            Create Free Account
          </button>
        </div>

        {/* Note */}
        <p className="text-center text-sm text-gray-500 mt-6">
          It's free to sign up and access resources!
        </p>
      </div>
    </div>
  );
}

export default SignInModal;
